/* Human Tech Medica: rullgardinsmenyn i sidhuvudet öppnas när man håller musen över den.
   Gäller bara på dator (mus och bred skärm). På mobil och med tangentbord fungerar menyn som vanligt. */
(function () {
  var kanHovra = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var STANG_EFTER = 200; /* ms, så att menyn inte stängs när musen passerar glappet ner till listan */

  function satt(details, oppen) {
    var summary = details.querySelector('summary');
    if (oppen) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
    }
    if (summary) summary.setAttribute('aria-expanded', oppen ? 'true' : 'false');
  }

  function init(details) {
    if (details.dataset.htmHover) return;
    details.dataset.htmHover = '1';
    var timer;

    details.addEventListener('mouseenter', function () {
      if (!kanHovra.matches) return;
      clearTimeout(timer);
      document.querySelectorAll('.header__inline-menu details[open]').forEach(function (annan) {
        if (annan !== details) satt(annan, false);
      });
      satt(details, true);
    });

    details.addEventListener('mouseleave', function () {
      if (!kanHovra.matches) return;
      clearTimeout(timer);
      timer = setTimeout(function () { satt(details, false); }, STANG_EFTER);
    });

    /* Ett musklick på rubriken ska inte stänga menyn som redan öppnats med hovring.
       Tangentbordet (Enter/mellanslag) fungerar som vanligt. */
    var summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function (e) {
        if (kanHovra.matches && e.detail > 0 && details.hasAttribute('open')) e.preventDefault();
      });
    }
  }

  function alla() {
    document.querySelectorAll('.header__inline-menu header-menu > details').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alla);
  } else {
    alla();
  }
  document.addEventListener('shopify:section:load', alla);
})();
